import ComplianceView from "./View";
import ComplianceList from "./List";

export { ComplianceView, ComplianceList }